<h2 *ngIf="showStepInfo">
  {{ isDoneStep ? "" : "STEP " + (stepIndex + 1) + (name ? " - " + name : "") }}
</h2>
<ng-content></ng-content>
